import { Users } from '@platform/client';
import { CheckBox, Modal } from '@platform/components';
import { useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';

export const TermsAndConditionsModal = ({ isOpen }: { isOpen: boolean }) => {
  const [agreed, setAgreed] = useState(false);
  const queryClient = useQueryClient();
  const agreeToTermsAndConditions = Users.useAgreeToTermsAndConditions({
    mutation: {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: Users.getGetCurrentUserQueryKey() });
      },
    },
  });
  return (
    <Modal
      title="We've Updated our Terms and Policies"
      isOpen={isOpen}
      variant='dialog'
      headerDivision='divider'
      primaryCTA={{
        text: 'Confirm & continue',
        callback: () => agreeToTermsAndConditions.mutate(),
        isDisabled: () => !agreed,
      }}
      dismissable={false}
      ignoreExtraPadding
    >
      <p className='text-gray-500 mb-8'>
        We've updated our Terms of Use and Privacy Policy to improve transparency around data
        sharing and reflect our current programs.
      </p>
      <CheckBox
        onChange={(isSelected) => setAgreed(isSelected)}
        size='sm'
        description={
          <p>
            I agree to the{' '}
            <a className='blue-link' href='/terms-of-use' target='_blank' rel='noopener noreferrer'>
              Terms of Use
            </a>{' '}
            and{' '}
            <a
              className='blue-link'
              href='/privacy-policy'
              target='_blank'
              rel='noopener noreferrer'
            >
              Privacy Policy
            </a>
          </p>
        }
      />
    </Modal>
  );
};
